<template>
  <div>
    <b-row>
      <b-col class="m-0">
        <ulu-inquiry-order-charts />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <ulu-order-charts />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-inquiry-order-charts": () =>
      import("@/components/dashboard/inquiry_order/InquiryOrderCharts.vue"),
    "ulu-order-charts": () =>
      import("@/components/dashboard/inquiry_order/OrderCharts.vue")
  }
};
</script>
